import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MilestoneTaskListComments from "./MilestoneTaskListComments";
import MilestoneTaskListDocument from "./MilestoneTaskListDocument";
import MilestoneTaskListActivity from "./MilestoneTaskListActivity";
import MilestoneTaskListLogHour from "./MilestoneTaskListLogHour";
import MilestoneTaskListSubtask from "./MilestoneTaskListSubtask";
import MilestoneTaskListIssue from "./MilestoneTaskListIssue";
import { fetchEntityById,} from "../../../apis/apiService";
import MilestoneSubTaskStatusTimeline from "./MilestoneTaskListStatus.jsx";
import {
  useFetchGetAllProjectBasedUserNameListQuery,
  useFetchMilestoneTaskActivityQuery,
  useFetchMilestoneTaskViewQuery,
  useFetchMilestoneDetailsQuery,
} from "../../../slice/logdetailSlice.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CommonTaskDetail } from "../../common/Task/CommonTaskDeatil.js";
export const MilestoneTasklistDetailTabs = ({
  MilestoneDetail,
  taskid,
  login_user_name,
  login_user_id,
  selectedUser,
  owner_name,
  login_user_role,
  document_count,
  comment_count,
  owners,
  logHours,
  refetch,
}) => {
  // const { id, name } = useParams();
  // //console.log("MilestoneTasklist_details :", MilestoneDetail);
  // const { owner: owner_name } = MilestoneDetail;
  // const login_users = useSelector(
  //   (state) => state.selectOptions?.loginUserName
  // );
  // const { id: login_user_id, name: login_user_name } = login_users;
  // //console.log(" MilestoneTasklist_details login_users : ", login_users);
  const isOwner = owners?.some((owner) => owner.user_id === login_user_id);
  // const [subtaskCount, setSubtaskCount] = useState(0);
  const [subtasks, setSubtasks] = useState([]);
  const [loading, setLoading] = useState(false);

  // const fetchSubtaskCount = async () => {
    const fetchSubtasks = async (isSilent = false) => {
    if (!isSilent) setLoading(true);
    try {
      const response = await fetchEntityById("milestones/task/subtask", taskid);
      if (response?.subtasks) {
        // setSubtaskCount(response.subtasks.length);
          const formattedTasks = response.subtasks.map((item) => ({
          ...item,
          id: item.id || item.task_id,
        }));
        setSubtasks(formattedTasks);
      }
    } 
    catch (error) {
      // console.error("Error fetching subtask count:", error);
      console.error("Error fetching subtasks:", error);
    } 
    finally {
      if (!isSilent) setLoading(false);
    }
  };

  const [issues, setIssues] = useState([]);
  const fetchIssues = async (isSilent = false) => {
    if (!isSilent) setLoading(true);
    try {
      const response = await fetchEntityById("milestones/task/issue/show", taskid);
      if (response?.data) {
        setIssues(response.data);
      }
    } 
    catch (error) {
      console.error("Error fetching issues:", error);
    } 
    finally {
      if (!isSilent) setLoading(false);
    }
  };

  useEffect(() => {
    if (taskid) {
      // fetchSubtaskCount();
       fetchSubtasks();
       fetchIssues();
    }
  }, [taskid]);

  const subtaskCount = subtasks.length;
  const issuesCount = issues.length;

  return (
    <div className=" ">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-3" role="presentation">
          <button
            className=" active text-rgba-gray R_btn"
            id="Comments-tab"
            data-bs-toggle="tab"
            data-bs-target="#Comments"
            type="button"
            role="tab"
            aria-controls="Comments"
            aria-selected="true"
          >
            Comments ({comment_count})
          </button>
        </li>

        <li className="nav-item pe-3" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Subtasks-tab"
            data-bs-toggle="tab"
            data-bs-target="#Subtasks"
            type="button"
            role="tab"
            aria-controls="Subtasks"
            aria-selected="false"
          >
            Subtasks ({subtaskCount})
          </button>
        </li>
        
        <li className="nav-item pe-3" role="presentation">
          {["ADMIN", "MANAGER"].includes(login_user_role) ||
          login_user_role === "CLIENT" ||
          selectedUser === login_user_id ||
          isOwner ? (
            <button
              className=" text-rgba-gray R_btn"
              id="LogHours-tab"
              data-bs-toggle="tab"
              data-bs-target="#LogHours"
              type="button"
              role="tab"
              aria-controls="LogHours"
              aria-selected="false"
            >
              Log Hours({logHours})
            </button>
          ) : null}
        </li>

        <li className="nav-item pe-3" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Status-tab"
            data-bs-toggle="tab"
            data-bs-target="#Status"
            type="button"
            role="tab"
            aria-controls="Status"
            aria-selected="false"
          >
            Status Timeline
          </button>
        </li>

        <li className="nav-item pe-3" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Documents-tab"
            data-bs-toggle="tab"
            data-bs-target="#Documents"
            type="button"
            role="tab"
            aria-controls="Documents"
            aria-selected="false"
          >
            Documents ({document_count})
          </button>
        </li>

        <li className="nav-item pe-3" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Issues-tab"
            data-bs-toggle="tab"
            data-bs-target="#Issues"
            type="button"
            role="tab"
            aria-controls="Issues"
            aria-selected="false"
          >
            Issues ({issuesCount})
          </button>
        </li>

        <li className="nav-item pe-3" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="ActivityStream-tab"
            data-bs-toggle="tab"
            data-bs-target="#ActivityStream"
            type="button"
            role="tab"
            aria-controls="ActivityStream"
            aria-selected="false"
          >
            Activity Stream
          </button>
        </li>

      </ul>
      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="Comments"
          role="tabpanel"
          aria-labelledby="Comments-tab"
        >
          <MilestoneTaskListComments MilestoneDetails={MilestoneDetail} />
        </div>

        <div
          className="tab-pane fade"
          id="Subtasks"
          role="tabpanel"
          aria-labelledby="Subtasks-tab"
        >
          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "150px" }}>
              <span className="text-rgba-gray fw-semibold">Loading...</span>
            </div>
          ) : (
            <MilestoneTaskListSubtask 
              MilestonesubTask={subtasks} 
              fetchMilestonesubtask={fetchSubtasks} 
            />
          )}
        </div>

        <div
          className="tab-pane fade"
          id="LogHours"
          role="tabpanel"
          aria-labelledby="LogHours-tab"
        >
          {/* <MilestoneTaskListLogHour /> */}
          <MilestoneTaskListLogHour refetchParentTask={refetch} />
        </div>
         
        <div
          className="tab-pane fade"
          id="Status"
          role="tabpanel"
          aria-labelledby="Status-tab"
        >
          <MilestoneSubTaskStatusTimeline />
        </div>

        <div
          className="tab-pane fade"
          id="Documents"
          role="tabpanel"
          aria-labelledby="Documents-tab"
        >
          <MilestoneTaskListDocument />
        </div>

        <div
          className="tab-pane fade"
          id="Issues"
          role="tabpanel"
          aria-labelledby="Issues-tab"
        >
          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "150px" }}>
              <span className="text-rgba-gray fw-semibold">Loading...</span>
            </div>
          ) : (
            <MilestoneTaskListIssue 
              MilestonetaskIssue={issues} 
              fetchMilestonetaskIssue={fetchIssues} 
            />
          )}
        </div>

        <div
          className="tab-pane fade"
          id="ActivityStream"
          role="tabpanel"
          aria-labelledby="ActivityStream-tab"
        >
          <MilestoneTaskListActivity />
        </div>
      </div>
    </div>
  );
};

const MilestoneTasklistDetailComponent = () => {
  const { id } = useParams();
  const { project_id, milestone_id, task_list_id: TaskListId } = useParams();
  const { data: project_based_users, refetch: project_based_users_refetch } = useFetchGetAllProjectBasedUserNameListQuery(project_id);
  const navigate = useNavigate();
  const {
    data: task_view,
    isLoading,
    refetch,
  } = useFetchMilestoneTaskViewQuery(id);
  const { data: milestone_detail } = useFetchMilestoneDetailsQuery(milestone_id);
  const { refetch: task_activity_status } = useFetchMilestoneTaskActivityQuery(id);
  //console.log("task_view_data :", task_view);

  const handleBoxClick = (task_id) => {
    // navigate(
    //   `/projects/projectDetail/milestone/MilestoneDetail/MilestoneSubTasklist/:taskId/TasklistDetail/${task_id}`
    // );
    navigate(
      `/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${milestone_id}/MilestoneSubTasklist/${TaskListId}/TasklistDetail/${task_id}`,
    );
  };

  return (
    <>
      <CommonTaskDetail
        project_id={project_id}
        id={id}
        TaskListId={TaskListId}
        handleBoxClick={handleBoxClick}
        showPath="milestones/task"
        updatePath="milestones/task"
        refetch={refetch}
        task_view={task_view}
        isLoading={isLoading}
        project_based_users={project_based_users}
        project_based_users_refetch={project_based_users_refetch}
        task_activity_status={task_activity_status}
        isMilestoneDetail={true}
        istaskDetail={false}
        overriddenProjectName={milestone_detail?.project_name}
      />
    </>
  );
};
export default MilestoneTasklistDetailComponent;
